<template>
  <div class="homePage">
    <div class="con-pop-top">
      <div class="con-pop-top-l" @click="goHome">
        <img
          src="https://www.fotile.com/webstatic/Public/Mobile/img/global/logo_20181123.png"
          alt=""
          class="a-logo"
        />
      </div>
      <div class="con-pop-top-r" @click="productAskClick">产品咨询</div>
    </div>
    <!-- items -->
    <h3 class="page-subtitle">集成烹饪中心</h3>
    <div class="swiper-container-nav">
      <div class="swiper-slide p-nav-item swiper-slide-active">
        <a href="https://www.fotile.com/ZT_integration_centerNew/index.html#/">
          <img
            src="https://hsimage.fotile.com/202109171609224255180.png"
            alt="第2代集成烹饪中心"
          />
          <strong>第2代集成<br />烹饪中心</strong>
        </a>
      </div>
      <div class="swiper-slide x2-nav-item">
        <a href="https://www.fotile.com/h5/hero/jcprzx.html?target=x2">
          <img
            src="https://hstestweb.efotile.com/webstatic/Public/Mobile/hd/jcprzx/images/X2.png"
            alt="X系列领先版"
          />
          <strong>X系列<br />领先版</strong>
        </a>
      </div>

      <div class="swiper-slide x-nav-item">
        <a href="https://www.fotile.com/h5/hero/jcprzx.html?target=x1">
          <img
            src="https://hstestweb.efotile.com/webstatic/Public/Mobile/hd/jcprzx/images/X1-20200514.jpg"
            alt="X系列豪华版"
          />
          <strong>X系列<br />豪华版</strong>
        </a>
      </div>
      <div class="swiper-slide J-nav-item">
        <a href="https://www.fotile.com/onlineh5/jxilie/">
          <img
            src="https://hsimage.fotile.com/e7520440-c750-4649-ba5b-feebf6a718b8.png"
            alt="J系列"
          />
          <strong>J系列</strong>
        </a>
      </div>
      <div class="swiper-slide z-nav-item">
        <a
          href="https://www.fotile.com/rehandling.html?cate=7&amp;cate=10&amp;utm_source=fotile-jcprzx-liuzi"
        >
          <img
            src="https://hstestweb.efotile.com/webstatic/Public/Mobile/hd/jcprzx/images/Z-125@2x.png"
            alt="Z系列"
          />
          <strong>Z系列</strong>
        </a>
      </div>
    </div>
    <!-- <div class="top-swipe por">
      <div v-for="(item, index) in bannerList" :key="index">
        <img
          v-if="index == 0"
          class="banner-text1"
          src="../assets/banner1-text1@3x.jpg"
          alt=""
        />
        <img v-if="item.type === '1'" class="swipe-bg" :src="item.src" alt="" />
        <div
          v-else-if="item.type === '2'"
          class="ad-video"
          :style="{ backgroundImage: 'url(' + item.backgroundImage + ')' }"
        ></div>
        <div
          class="ad-video-pbox"
          v-if="item.type === '2'"
          @click="goVideo(item)"
        >
          <img class="ad-video-play" src="../assets/play@2x.png" alt="" />
        </div>
      </div>
    </div> -->
    <!-- <van-swipe class="top-swipe" :autoplay="3000">
      <van-swipe-item v-for="(item, index) in bannerList" :key="index">
        <img
          v-if="index == 0"
          class="banner-text1"
          src="../assets/banner1-text1@3x.png"
          alt=""
        />
        <img v-if="item.type === '1'" class="swipe-bg" :src="item.src" alt="" />
        <div
          v-else-if="item.type === '2'"
          class="ad-video"
          :style="{ backgroundImage: 'url(' + item.backgroundImage + ')' }"
        ></div>
        <div
          class="ad-video-pbox"
          v-if="item.type === '2'"
          @click="goVideo(item)"
        >
          <img class="ad-video-play" src="../assets/play@2x.png" alt="" />
        </div>
      </van-swipe-item>
    </van-swipe> -->
    <!-- <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="banner-box">
          <img class="banner-img" src="../assets/bg-001@2x.png" alt="" />
        </div>
      </swiper-slide>
      <swiper-slide>I'm Slide 2</swiper-slide>
      <swiper-slide>I'm Slide 3</swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper> -->
    <!-- <div class="home-con-top">
      <img class="bg-img" src="../assets/bg-001@2x.png" alt="" />
      <img src="../assets/text-001@2x.png" alt="" class="title1" />
      <img src="../assets/text-002@2x.png" alt="" class="title2" />
      <img src="../assets/con0-tips@2x.png" alt="" class="title3" />
    </div> -->
    <!-- <div class="home-con-1">
      <img class="bg-img" src="../assets/con-bg2@3x.png" alt="" />
      <img class="text-box-title" src="../assets/con2-text1@3x.png" alt="" />
      <img class="text-box-text2" src="../assets/con2-text2@3x.png" alt="" />
    </div> -->
    <div class="home-con-1">
      <img class="bg-img" src="../assets/banner1-text1@3x.jpeg" alt="" />
    </div>
    <div class="home-con-1">
      <img class="bg-img" src="../assets/con2-bg.jpg" alt="" />
    </div>
    <div class="home-con-1">
      <img class="bg-img" src="../assets/con3-bg.jpg" alt="" />
    </div>
    <div class="home-con-1">
      <img class="bg-img" src="../assets/con4-bg.jpg" alt="" />
    </div>
    <div class="home-con-1">
      <img class="bg-img" src="../assets/con5-bg.jpg" alt="" />
    </div>
    <div class="home-con-1">
      <img class="bg-img" src="../assets/con6-bg.jpg" alt="" />
    </div>
    <div class="home-con-1">
      <img class="bg-img" src="../assets/con7-bg.jpg" alt="" />
    </div>
    <!-- <div class="home-con-2">
      <img class="bg-img" src="../assets/con-bg3@3x.png" alt="" />
      <img class="text-box-title" src="../assets/con3-text1@3x.png" alt="" />
    </div> -->

    <!-- <div class="home-con-3">
      <img class="bg-img" src="../assets/con-bg4@3x.png" alt="" />
      <img class="text-box-title" src="../assets/con4-text1@3x.png" alt="" />
    </div> -->

    <!-- <div class="home-con-4">
      <img class="bg-img" src="../assets/con-bg5@3x.png" alt="" />
      <img class="text-box-title" src="../assets/con5-text1@3x.png" alt="" />
      <img class="text-box-text2" src="../assets/con5-text2@3x.png" alt="" />
    </div> -->

    <!-- <div class="home-con-5">
      <img class="bg-img" src="../assets/con-bg6@3x.png" alt="" />
      <img class="text-box-title" src="../assets/con6-text1@3x.png" alt="" />
      <img class="text-box-title2" src="../assets/con6-text2@3x.png" alt="" />
    </div> -->

    <!-- <div class="home-con-6">
      <img class="bg-img" src="../assets/con-bg7@3x.png" alt="" />
      <img class="text-box-title" src="../assets/con7-text1@3x.png" alt="" />
    </div> -->

    <!-- <div class="home-con-7">
      <img class="bg-img" src="../assets/con-bg8@3x.png" alt="" />
      <img class="text-box-title" src="../assets/con8-text1@3x.png" alt="" />
      <img class="text-box-text2" src="../assets/con8-text2@3x.png" alt="" />
      <img class="text-box-text3" src="../assets/con8-text3@3x.png" alt="" />
      <img class="text-box-text4" src="../assets/con8-text4@3x.png" alt="" />
    </div> -->
    <!-- footer -->
    <div class="con-footer">
      <footer>
        <div class="footNav">
          <ul>
            <li class="bBor tBor">
              <!--
                :class="openFlag ? 'on' : ''" -->
              <a
                href="
                javascript:;"
                id="ljcp"
                class="first"
                >了解产品</a
              >
              <div
                class="list proList ul-box"
                id="footerMenuWapper"
                ref="footerMenu1"
              >
                <!--:style="{height:liHeight+'px'}"
                    :class="openFlag? 'show' : 'hide'" style="height:300px" -->
                <a
                  v-for="item in menuInfo"
                  :key="item.id"
                  :style="
                    'background-image: url(' +
                    item.categoryPathUnsel +
                    ');overflow: hidden;'
                  "
                  :href="['https://www.fotile.com/h5/chanpin/' + item.id + '/']"
                  >{{ item.name }}</a
                >
              </div>
            </li>

            <li class="bBor">
              <a href="javascript:;">购买</a>
              <div class="list serList">
                <a
                  href="https://www.efotile.com/?utm_source=fotile-guanwang-shouye-weibu-shangcheng0303"
                  class="bBor"
                  >方太商城</a
                >
                <a
                  href="https://mall.jd.com/index-1000000907.html?cu=true&utm_source=kong&utm_medium=tuiguang&utm_campaign=t_1001006693_1089_5742_null"
                  class="bBor"
                  >方太京东旗舰店</a
                >
                <a
                  href="https://equity.tmall.com/tm?agentId=976428&_bind=true&bc_fl_src=tmall_market_llb_1_1141052&llbPlatform=_pube&llbOsd=1"
                  class="bBor"
                  >方太天猫旗舰店</a
                >
                <a
                  href="https://www.fotile.com/service/city/queryCity.html?utm_source=fotile-guanwang-shouye-dibu-zhuanmaid0303"
                  class=""
                  >专卖店查询</a
                >
              </div>
            </li>
            <li class="link">
              <a
                href="https://www.fotile.com/h5/services/fuwuwangluo.html"
                class="bBor"
                >专卖店查询</a
              >
            </li>
            <li class="bBor">
              <a href="javascript:;">服务与帮助</a>
              <div class="list serList">
                <a
                  href="https://www.fotile.com/h5/services/guanwangfuwu.html"
                  class="bBor"
                  >预约服务</a
                >
                <a
                  href="http://cemwz.fotile.com/weixin/index?indexNu=6&useType=2"
                  class="bBor"
                  >服务进度查询</a
                >
                <a
                  href="https://www.fotile.com/h5/services/fuwuzhengce.html"
                  class="bBor"
                  >服务政策</a
                >
                <a
                  href="https://www.fotile.com/h5/services/fuwushoufei.html"
                  class="bBor"
                  >服务收费标准</a
                >
                <a
                  href="http://wechat.fotile.com/maintenance/newcms/collection/collection.html?utm_source=fotile-shiyongzhinan-dh"
                  class="bBor"
                  >产品使用指南</a
                >
                <a
                  href="https://www.fotile.com/h5/services/fuwuwangluo.html"
                  class=""
                  >专卖店查询</a
                >
              </div>
            </li>

            <li class="bBor">
              <a href="javascript:;">方太幸福家</a>
              <div class="list serList">
                <a href="javascript:;" class="bBor" onclick="goXinfu()"
                  >幸福家首页</a
                >
                <a href="https://datayi.cn/oeNzZY1" class="">APP下载</a>
              </div>
            </li>

            <li class="bBor">
              <a href="javascript:;">关于方太</a>
              <div class="list serList">
                <a
                  href="https://www.fotile.com/h5/brand/about.html"
                  class="bBor"
                  >方太简介</a
                >
                <a
                  href="https://www.fotile.com/h5/brand/contact.html"
                  class="bBor"
                  >联系我们</a
                >
                <a href="https://www.fotile.com/h5/news" class="bBor"
                  >方太资讯</a
                >
                <a href="https://www.fotile.com/news/567.html" class="bBor"
                  >方太文化研究院</a
                >
                <a
                  href="https://www.fotile.com/h5/brand/obligation.html"
                  class="bBor"
                  >社会责任</a
                >
                <a href="https://www.fotile.com/h5/video.html" class="bBor"
                  >方太影像</a
                >
                <a href="https://www.fotile.com/h5/programme.html" class="bBor"
                  >工程合作</a
                >
                <a href="https://www.fotile.com/h5/brand/dealer.html" class=""
                  >经销加盟</a
                >
              </div>
            </li>
          </ul>

          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            网站中涉及的数据、统计资料或调查结果（如有）等属于引证内容的，除特别标注外，其余均来自方太。
          </div>
          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *高效滤除重金属：根据浙（省）疾控检字第201901180号检测报告显示，可有效滤除砷、镉、铬（六价）、铅等重金属。
          </div>
          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *保留有益矿物质：根据中国家用电器检测所WCjs-19-40161号检测报告显示，可保留钙、钾、镁、钠，等矿物质。
          </div>
          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *不跑烟：在方太实验室规定条件下测试，肉眼未见明显的油烟逃逸。
          </div>
          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *龙头一开，热水即来：需提前开启循环功能，由于循环水路到出水点具体安装可能因龙头、花洒或支路产生一小截冷水。
          </div>
          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *还能去果蔬农残：指能有效去除果蔬表面的氧化乐果、乐果等农药残留。
          </div>
          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *同层同温：在方太实验室规定条件下测试，热风烘焙模式下180℃条件下，同层温差小于7℃。
          </div>
          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *双倍：加热盘与水的接触面积约是上一代产品的2倍。
          </div>
          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *110℃：在方太试验室规定条件下，过温蒸模式下测得。
          </div>
          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *根据广东省微生物分析检测中心等机构的检测数据，方太水槽洗碗机对乙酰甲胺磷、氧化乐果、乐果等农药的去除率均达到了90%以上。
          </div>
          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *根据广东省微生物分析检测中心等机构的检测数据，方太水槽洗碗机对大肠杆菌和金黄色葡萄球菌的去除率均达到99.99%。
          </div>
          <div
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *广东微生物分析检测中心报告编号2016FM2255-1
          </div>
          <div
            class="tipTxt2"
            style="
              color: rgba(0, 0, 0, 0.6);
              padding-bottom: 10px;
              text-align: left;
              font-size: 12px;
              line-height: 16px;
            "
          >
            *中式蒸箱创新者：中国发明专利号ZL201210327073.2
          </div>

          <div class="icons">
            <!-- <a
                href="https://m.weibo.cn/u/1768742990"
                class="sina"
              ></a> -->
            <a href="javascript:;" class="wechat maBtn" @click="TapWx"></a>
            <a
              href="http://idinfo.zjamr.zj.gov.cn/bscx.do?method=lzxx&id=3302183302180000000976"
              class="logo3"
            ></a>
            <a href="javascript:;" class="logo4"></a>
          </div>

          <div
            style="
              color: rgba(0, 0, 0, 0.4);
              padding-bottom: 15px;
              text-align: center;
              font-size: 12px;
              line-height: 16px;
            "
          >
            <a
              style="color: rgba(0, 0, 0, 0.4)"
              href="http://beian.miit.gov.cn"
              target="_blank"
              >浙ICP备05083555号-1</a
            >
            <br />
            <a
              style="color: rgba(0, 0, 0, 0.4)"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33029202000036"
              target="_blank"
              >浙公网安备 33029202000036号</a
            >
          </div>

          <div class="links">
            <!--      <a href="/humanism/map.html">网站地图</a>-->
            <!--      <u>|</u>-->
            <a href="https://www.fotile.com/h5/brand/provisions.html"
              >法律声明</a
            >
            <u>|</u>
            <a href="http://fotileglobal.com/">海外官网</a>
          </div>
        </div>
      </footer>
    </div>
    <!-- 微信二维码 弹窗 -->
    <van-overlay :show="isWechat" @click="isWechat = false" class="maBox">
      <img src="../assets/wechat_wenjuan_qrcode.jpg" width="100" />
    </van-overlay>
    <!-- video 弹窗 -->
    <van-overlay :show="videoFlag" @click="closeVideo" class="video-overlay">
      <div class="wrapper-video" @click.stop>
        <img
          src="../assets/close@2x.png"
          alt=""
          class="wrapper-video-close"
          @click="closeVideo"
        />
        <!-- <video
          class="ad-video2"
          :src="showVurl"
          controls
        ></video> -->
        <vue-aliplayer-v2
          :source="showVurl"
          ref="alipaly"
          :options="videoOptions"
          class="wrap"
          @cancelFullScreen="handleCancelFullScreen"
          @requestFullScreen="handleRequestFullScreen"
        />
      </div>
    </van-overlay>
  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import $ from "jquery";
import banner1 from "@/assets/banner1@3x.png";
import banner2 from "@/assets/banner2.png";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        // loop: true,
        // autoplay: {
        //   // delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
      },
      bannerList: [
        {
          type: "1",
          src: banner1,
        },
        // {
        //   type: "2",
        //   backgroundImage: banner2,
        //   src:
        //     "https://hsvod.fotile.com/09b806adae334c50898748479fc4f069/550af7e9ec0242278772132d15cace96-b33f4956708198d251fe3bbeeedfb903-sd.m3u8",
        // },
      ],
      videoOptions: {
        rePlay: false, //自动循环播放。
        height: "100%",
        width: "100%",
        videoHeight: "auto",
        useH5Prism: false,
        isLive: false, //是不是直播
        controlBarVisibility: "always",
        preload: false,
        autoplay: false,
        function(player) {
          //先静音然后播放
          player.mute();
          player.play();
        },
      },
      showVurl: "", //video播放url
      videoFlag: false, //video播放
      menuInfo: [], //footer-menu
      openFlag: false,
      openFlag2: false,
      openFlag3: false,
      openFlag4: false,
      openFlag5: false,
      isWechat: false,
    };
  },
  // computed: {
  //   swiper() {
  //     return this.$refs.mySwiper.swiper;
  //   },
  // },
  created() {
    document.title = "方太集成烹饪中心制冷系列";
    this.getGoodsMenu();
  },
  mounted() {
    const that = this;
    that.$nextTick(() => {
      $(".footNav li>a").click(function () {
        $(this).parents("li").toggleClass("on");
        $(this).parents("li").find(".list").slideToggle();
      });
    });
  },
  methods: {
    productAskClick() {
      $.getScript(
        "//dl.ntalker.com/js/xn6/ntkfstat.js?siteid=kf_9729",
        function () {
          NTKF.im_openInPageChat("kf_9729_1482141141679");
        }
      );
    },
    // 获取菜单
    getGoodsMenu() {
      let that = this;
      that.$api.article
        .getGoodsMenu({})
        .then((res) => {
          that.menuInfo = res.data.data;
          // let nlength = res.data.data.length;
          // that.liHeight = Math.ceil(nlength / 2) * 46.5;
        })
        .catch((err) => {})
        .finally((all) => {});
    },
    TapWx() {
      this.isWechat = !this.isWechat;
    },
    // 打开产品-菜单
    openList(type) {
      if (type === 1) {
        this.openFlag = !this.openFlag;
      } else if (type === 2) {
        this.openFlag2 = !this.openFlag2;
      } else if (type === 3) {
        this.openFlag3 = !this.openFlag3;
      } else if (type === 4) {
        this.openFlag4 = !this.openFlag4;
      } else if (type === 5) {
        this.openFlag5 = !this.openFlag5;
      }
    },
    goHome() {
      window.location.href = "https://www.fotile.com/";
    },
    handleRequestFullScreen(e) {},
    handleCancelFullScreen(e) {
      console.log(`退出`, e);
      this.$refs.alipaly.pause();
    },
    closeVideo() {
      this.$refs.alipaly.pause();
      this.videoFlag = false; // 暂停播放
    },
    goVideo(item) {
      this.videoFlag = true;
      console.log("播放", item);
      this.showVurl = item.src;
      this.$refs.alipaly.replay();
      // this.$refs.alipaly.requestFullScreen();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/common/home.scss";
</style>
<style>
/* .swiper-pagination-bullet-active {
  background-color: #fff !important;
}
.swiper-pagination-bullet {
  background: rgba(255, 255, 255, 0.5);
  opacity: 1;
} */
/* new 指示点 */
.van-swipe__indicators {
  left: 26px;
  bottom: 17px;
}
.van-swipe__indicator {
  opacity: 0.5;
}
.van-swipe__indicator:not(:last-child) {
  margin-right: 3px;
}
.van-swipe__indicator--active {
  width: 16px;
  height: 6px;
  background: #c60008 !important;
  border-radius: 3px;
  opacity: unset;
}
</style>
